export const SECONDS_TO_WAIT_AFTER_VIEWABILITY = 30;
export const REFRESH_KEY = 'refresh';
export const LOCATION_KEY = 'loc';
export const CATEGORY_KEY = 'event_cat';
export const PAGE_TYPE_KEY = 'pt';
export const GPT_LOCAL_STORAGE_KEY = 'evite-ppid';
export const GPT_UUID = 'c3b1f0d2-8a4e-4c5f-9b6d-7e1c8f3b2a1c'; // Unique identifier for Google Ads.
export const AMAZON_PUB_ID = '3107';
export const ADSERVER = 'googletag';


// pre-defined ad size bundles
export const PHOTO_SHARE_DESKTOP = [[970, 250], [300, 600]];
export const PHOTO_SHARE_MOBILE = [[300, 250]];
export const PHOTO_SHARE_GALLERY_DESKTOP = [[728,90]];
export const PHOTO_SHARE_GALLERY_MOBILE = [[320,50]];
export const TOP_LEADERBOARD_DESKTOP = [[728, 90], [970, 90]];
export const LEADERBOARD_DESKTOP = [[970, 250], ...TOP_LEADERBOARD_DESKTOP];
export const LEADERBOARD_MOBILE = [[300, 50], [320, 50], [320, 100]];
export const SIDEPANEL = [[160, 600], [300, 600], [300, 250]];


export const ID_PREFIX_BY_CONFIG_KEY = {
    'topLeaderboard' : 'google-free-banner',
    'leaderboard' : 'google-free-banner',
    'sidePanel' : '/5480/Evite_Invitation_Sidebar_300x600_Desktop',
    'photoShare' : 'google-free-banner-photoShare',
    'photoShareGallery' : 'google-free-banner-photoShareGallery',
}
